import { Button, Content } from '@sh24/ui-components'
import React, { ReactNode } from 'react'

const PreBookingContent = ({
  handleContinue,
  preBookingContent,
}: {
  handleContinue: () => void
  preBookingContent: ReactNode
}) => (
  <>
    {preBookingContent && (
      <div className="mb-md">
        <Content width="wide" textAlign="left" content={preBookingContent} />
      </div>
    )}
    {handleContinue && (
      <div className="row row-centered">
        <Button variation="primary" onClick={handleContinue} text="Continue to booking page" />
      </div>
    )}
  </>
)

export default PreBookingContent
